export default __webpack_public_path__ + "static/media/25-1.2bdfc337.mp3";